export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/index.vue'),
    /* no children */
    meta: {
      "layout": false
    }
  },
  {
    path: '/:path(.*)',
    name: '/[...path]',
    component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/[...path].vue'),
    /* no children */
    meta: {
      "layout": false
    }
  },
  {
    path: '/access-management',
    /* internal name: '/access-management' */
    /* no component */
    children: [
      {
        path: '',
        name: '/access-management/',
        component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/access-management/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/auth',
    name: '/auth',
    component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/auth.vue'),
    children: [
      {
        path: '',
        name: '/auth/',
        component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/auth/index.vue'),
        /* no children */
      },
      {
        path: 'auth-callback',
        name: '/auth/auth-callback',
        component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/auth/auth-callback.vue'),
        /* no children */
      },
      {
        path: 'callback',
        name: '/auth/callback',
        component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/auth/callback.vue'),
        /* no children */
      },
      {
        path: 'forgot-password',
        name: '/auth/forgot-password',
        component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/auth/forgot-password.vue'),
        /* no children */
      },
      {
        path: 'otp',
        name: '/auth/otp',
        component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/auth/otp.vue'),
        /* no children */
      },
      {
        path: 'ringcentral-callback',
        name: '/auth/ringcentral-callback',
        component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/auth/ringcentral-callback.vue'),
        /* no children */
        meta: {
          "layout": "blank",
          "auth": true
        }
      },
      {
        path: 'sign-in',
        name: '/auth/sign-in',
        component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/auth/sign-in.vue'),
        /* no children */
      },
      {
        path: 'sign-in-2',
        name: '/auth/sign-in-2',
        component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/auth/sign-in-2.vue'),
        /* no children */
      },
      {
        path: 'sign-up',
        name: '/auth/sign-up',
        component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/auth/sign-up.vue'),
        /* no children */
      }
    ],
    meta: {
      "layout": false
    }
  },
  {
    path: '/call',
    /* internal name: '/call' */
    /* no component */
    children: [
      {
        path: ':telephonySessionId',
        name: '/call/[telephonySessionId]',
        component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/call/[telephonySessionId].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/calls',
    /* internal name: '/calls' */
    /* no component */
    children: [
      {
        path: '',
        name: '/calls/',
        component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/calls/index.vue'),
        /* no children */
        meta: {
          "preserveDateRange": true
        }
      }
    ],
  },
  {
    path: '/dashboard',
    /* internal name: '/dashboard' */
    /* no component */
    children: [
      {
        path: '',
        name: '/dashboard/',
        component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/dashboard/index.vue'),
        /* no children */
        meta: {
          "preserveDateRange": true
        }
      }
    ],
  },
  {
    path: '/errors',
    name: '/errors',
    component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/errors.vue'),
    children: [
      {
        path: '',
        name: '/errors/',
        component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/errors/index.vue'),
        /* no children */
      },
      {
        path: '401',
        name: '/errors/401',
        component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/errors/401.vue'),
        /* no children */
        meta: {
          "layout": "blank"
        }
      },
      {
        path: '403',
        name: '/errors/403',
        component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/errors/403.vue'),
        /* no children */
        meta: {
          "layout": "blank"
        }
      },
      {
        path: '404',
        name: '/errors/404',
        component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/errors/404.vue'),
        /* no children */
        meta: {
          "layout": "blank"
        }
      },
      {
        path: '500',
        name: '/errors/500',
        component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/errors/500.vue'),
        /* no children */
        meta: {
          "layout": "blank"
        }
      },
      {
        path: '503',
        name: '/errors/503',
        component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/errors/503.vue'),
        /* no children */
        meta: {
          "layout": "blank"
        }
      }
    ],
    meta: {
      "layout": false
    }
  },
  {
    path: '/layout',
    /* internal name: '/layout' */
    /* no component */
    children: [
      {
        path: 'analysis',
        name: '/layout/analysis',
        component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/layout/analysis.vue'),
        /* no children */
      },
      {
        path: 'icons',
        name: '/layout/icons',
        component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/layout/icons.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/lead-tracker',
    /* internal name: '/lead-tracker' */
    /* no component */
    children: [
      {
        path: '',
        name: '/lead-tracker/',
        component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/lead-tracker/index.vue'),
        /* no children */
        meta: {
          "preserveDateRange": true
        }
      }
    ],
  },
  {
    path: '/legal',
    name: '/legal',
    component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/legal.vue'),
    /* no children */
    meta: {
      "auth": false,
      "layout": "blank"
    }
  },
  {
    path: '/settings',
    /* internal name: '/settings' */
    /* no component */
    children: [
      {
        path: '',
        name: '/settings/',
        component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/settings/index.vue'),
        /* no children */
      },
      {
        path: 'change-password',
        name: '/settings/change-password',
        component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/settings/change-password.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/staff-timeline',
    /* internal name: '/staff-timeline' */
    /* no component */
    children: [
      {
        path: '',
        name: '/staff-timeline/',
        component: () => import('/home/runner/work/RingcentralAnalysisPortal/RingcentralAnalysisPortal/src/pages/staff-timeline/index.vue'),
        /* no children */
        meta: {
          "preserveDateRange": true
        }
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

